import { useMemo } from 'react';
import { useUscgMapContext } from '../UscgMapContext';
import { type UscgSymbol } from './uscgSymbology';
import { getCentroidFromLocationPoints } from './getCentroidFromLocationPoints';

type UsePrimaryPointOptions = {
  selectedType?: UscgSymbol | null;
  centroidTypes?: UscgSymbol[];
};

export const usePrimaryPoint = ({
  selectedType = null,
  centroidTypes = [],
}: UsePrimaryPointOptions = {}) => {
  const { symbolDrawingState } = useUscgMapContext();

  return useMemo(() => {
    const points = symbolDrawingState.points;
    if (!points.length) return null;

    if (selectedType && centroidTypes.includes(selectedType)) {
      return getCentroidFromLocationPoints(points);
    }

    const singlePoint = points[0];
    return {
      longitude: singlePoint.longitude,
      latitude: singlePoint.latitude,
    };
  }, [symbolDrawingState.points, selectedType, centroidTypes]);
};
